export const OD_APP_DEFAULT = 'one-degree';
export const OD_COOKIES_PREFIX = 'one-degree';

export const cookieName = (key) => OD_COOKIES_PREFIX + '_' + key;

export const FETCHABLE_TYPE_MAP = {
  opportunities: 'Opportunity',
  organizations: 'Organization',
  collections: 'Collection'
};
